<template>
    <div class="app">
        <DefaultHeader @edit-profile="prepareEdit" @logout="logout" :fullName="fullName" :roleName="roleName" />
        <div class="app-body">
            <AppSidebar fixed>
                <SidebarHeader/>
                <div class="sidebar-header-c">
                    <div class="show-on-mobile" style="margin: 1em">
                        <div style="line-height: 1.2">{{ fullName }}</div>
                        <div class="small font-weight-bold">{{ roleName }}</div>
                    </div>
                </div>
                <SidebarForm/>
                <SidebarNav :navItems="nav"></SidebarNav>
            </AppSidebar>
            <main class="main">
                <CustomBreadcrumb :list="list"/>
                <div class="container-fluid">
                <router-view></router-view>
                </div>
            </main>
        </div>
        <DefaultFooter/>
        <b-modal id="modal-edit-profile" title="Edit Profile"
            centered no-close-on-backdrop no-close-on-esc hide-footer
        >
            <b-form-group
                label="Nama Admin" 
                :state="editNameState"
                description="Nama lengkap admin."
                invalid-feedback="Nama minimal 4 karakter."
            >
                <b-form-input v-model="edit.name" :state="editNameState" maxlength="100" />
            </b-form-group>
            <b-form-group
                label="Username" 
                :state="editUsernameState"
                description="Username untuk login."
                invalid-feedback="Username minimal 4 karakter."
            >
                <b-form-input
                    v-model="edit.username"
                    :state="editUsernameState"
                    maxlength="100"
                />
            </b-form-group>
            <b-form-group
                label="Password Baru" 
                :state="editPasswordState"
                description="Password untuk login. Kosongkan apabila tidak ingin diubah."
                invalid-feedback="Password minimal 4 karakter."
            >
                <b-form-input type="password" v-model="edit.password" :state="editPasswordState" maxlength="100" />
            </b-form-group>
            <b-form-group
                label="Ulangi Password Baru" 
                :state="editConfirmPasswordState"
                description="Mohon ketik ulang password. Kosongkan apabila tidak ingin diubah."
                invalid-feedback="Password tidak sama."
            >
                <b-form-input type="password" v-model="edit.confirmPassword" :state="editConfirmPasswordState" maxlength="100" />
            </b-form-group>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeEditProfile">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
import nav from '@/nav'
import { Sidebar as AppSidebar, SidebarForm, SidebarHeader, SidebarNav } from '@coreui/vue'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import DefaultHeader from './DefaultHeader'
import DefaultFooter from './DefaultFooter'
import CustomBreadcrumb from './CustomBreadcrumb'

export default {
    name: 'DefaultContainer',
    components: {
        AppSidebar,
        CustomBreadcrumb,
        DefaultHeaderDropdownAccnt,
        SidebarForm,
        SidebarHeader,
        SidebarNav,
        DefaultFooter,
        DefaultHeader
    },
    data () {
        return {

            nav: [],

            fullName: "",
            roleName: "",

            isSubmitting: false,

            input: {
                oldPassword: "",
                newPassword: "",
                confirmNewPassword: "",
                opType: "password",
                npType: "password",
                cpType: "password"
            },

            edit: {
                id: "",
                name: "",
                username: "",
                password: "",
                confirmPassword: ""
            },

        }
    },
    computed: {

        name () {
            return this.$route.name
        },

        list () {
            return this.$route.matched.filter((route) => (route.name || route.meta.label) && !route.meta.hideInBreadcrumb)
        },
        
        editNameState(){
            if(this.edit.name.length <= 0) return null
            return this.edit.name.length >= 4
        },
        editUsernameState(){
            if(this.edit.username.length <= 0) return null
            return this.edit.username.length >= 4
        },
        editPasswordState(){
            if(this.edit.password.length <= 0) return true
            return this.edit.password.length >= 4
        },
        editConfirmPasswordState(){
            if(this.edit.password.length <= 0) return true
            else if(this.edit.confirmPassword.length <= 0) return null
            return this.edit.confirmPassword == this.edit.password
        }

    },
    methods: {

        prepareEdit() {
            this.edit.id = localStorage.getItem("userId")
            this.edit.name = localStorage.getItem("fullname")
            this.edit.username = localStorage.getItem("username")
            this.edit.password = ""
            this.edit.confirmPassword = ""
            this.$bvModal.show("modal-edit-profile")
        },

        executeEditProfile() {

            let payload = {
                nama: this.edit.name,
                username: this.edit.username
            }

            if(!this.$helper.isBlank(this.edit.password)){
                payload["password"] = this.edit.password
            }

            this.isSubmitting = true

            this.$axios.post("admin/updateAdmin", payload).then(_ => {

                this.$helper.toastSuccess(this, "Data profile berhasil diubah!")
                this.$bvModal.hide("modal-edit-profile")
                this.fullName = this.edit.name
                localStorage.setItem("fullname", this.edit.name)
                localStorage.setItem("username", this.edit.username)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        logout() {

            var version = localStorage.getItem("version")
            localStorage.clear()
            sessionStorage.clear()
            localStorage.setItem("version", version)

            this.$router.push("/login")

        }

    },
    created() {

        // Auto-redirect to login page if token does not exist --> moved to router
        if(localStorage.getItem("token") == null) {
            this.$router.push({ path: "/login" })
            return
        }

        // this.$axios.get("user/check-token")

        this.fullName = localStorage.getItem("fullname")
        this.roleName = localStorage.getItem("roleName")

        // Consolidate navigation properties
        let navs = JSON.parse(JSON.stringify(nav.items))

        if(localStorage.getItem("roleId") != 1) {
            for(let i = 0; i < navs.length; i++){
                if(navs[i].permission == 1){
                    navs.splice(i, 1)
                }
            }
        }

        // let permissions = localStorage.getItem("permissions").split(",").map(it => Number(it))
        // console.log(permissions)

        // if(localStorage.getItem("roleId") != 1) { // Bukan superadmin, permission-based

        //     let newNav = []
        //     navs.forEach(item => {

        //         if(!item.hasOwnProperty("children") && (item.permission == null || permissions.includes(item.permission))) {
        //             newNav.push(item)
        //         }

        //         if(item.hasOwnProperty("children")) {

        //             newNav.push(item)

        //             let children = [];
        //             item.children.forEach(it => {
        //                 if(it.permission == null || permissions.includes(it.permission)) {
        //                     children.push(it)
        //                 }
        //             })

        //             item.children = children

        //             if(children.length == 0) {
        //                 newNav.pop();
        //             }

        //         }

        //     })

        //     this.nav = newNav

        // }
        // else {
            this.nav = navs
        // }

    },
    // mounted() {

    //     // Check versioning. Hard refresh if reload is required
    //     let reloadStatus = localStorage.getItem("reload")

    //     if(reloadStatus != null && reloadStatus == 1) {
    //         localStorage.removeItem("reload")
    //         window.location.reload()
    //     }

    // }
}
</script>
